<header class="Header_header" id="header" *transloco="let t" [class.is-sign-in-page]="isSignInPage">
  <div class="container-xl Header_inner scroll-animate" #animatedDiv>
    <a class="Header_logo" href="javascript:;" (click)="navigateToUrl()">
      <picture>
        @if (isInfoBannerDismissed || (isMobile$ | async) === false || showNavMenu) {
          @if (!showNavMenu) {
            <source [srcset]="assetUrl$ | async" />
          } @else {
            <source [srcset]="assetUrl$ | async" media="(min-width: 768px)" />

            <source [srcset]="'assets/images/logo-small.svg'" media="(max-width: 767px)" />
          }

          <img class="c-logo-image" [src]="assetUrl$ | async" alt="Logo" />
        }
      </picture>
    </a>

    <div class="right-container" [class.is-sign-in-page]="isSignInPage">
      <app-theme-switcher [enableLightTheme]="true"></app-theme-switcher>
      @if (translateService.enabled$ | async) {
        <app-language-dropdown [isSignInPage]="isSignInPage" [enableLightTheme]="true" />
      }
      <div class="login-container">
        <app-link
          type="tertiary"
          [label]="t('landing.navbar.buttonLabel')"
          (click)="navigateToUrl()"
        />
      </div>
    </div>
  </div>
</header>
